import {restapi} from "./restapi";
import {LossCategory} from "../models/types";

export function retrieveLossCategories(): Promise<LossCategory[]> {
    return restapi.get<LossCategory[]>("/api/v1/smt_core/loss_category/?__pagination__=0").then(res => res.data);
}
